import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { TiWarning } from 'react-icons/ti';
import { Stack } from '@mui/system';
import { useNavigate } from 'react-router';
import { IoClose } from 'react-icons/io5';
import { Box } from '@mui/material';

export default function AlertDialog(props) {
  const Nav = useNavigate();

  const handleNav = () => {
    Nav('/uploadocs', {
      state: props.data
    });
    props.handleClose();
  };

  return (
    <React.Fragment>
      <Dialog open={props.open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogContent>
          <Stack alignItems="center" gap={0}>
            <TiWarning fontSize={100} color="#EAA6A1" />
            <Box sx={{ position: 'absolute', right: 5, top: 5, fontSize: '25px', cursor: 'pointer' }} onClick={() => props.handleClose()}>
              <IoClose />
            </Box>

            <DialogContentText sx={{ color: '#364152' }}>
              KYC Team has requested a document reupload, Click proceed to continue
            </DialogContentText>
            <Button
              variant="contained"
              sx={{ borderRadius: '10px', marginTop: '10px', backgroundColor: '#592375' }}
              onClick={() => handleNav()}
            >
              Proceed
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
